module.exports = __webpack_public_path__ + "img/cheetah.721ea8b6.jpg";